import { Business } from 'model';
import { useGetBusinessQuery } from '../api/BusinessApi';
import { getBusinessImages } from '../util/getBusinessImages';
import { QuirkImage } from './QuirkImage';
import styles from './BusinessBanner.module.css';
export type BusinessBannerProps =
	| {
			business?: Business;
	  }
	| {
			id?: Business['_id'];
	  };
export function BusinessBanner(props: BusinessBannerProps) {
	const id = (props as { id?: Business['_id'] }).id;
	const { data } = useGetBusinessQuery(id ?? '', { skip: id === undefined });
	const business = (props as { business?: Business }).business ?? data;
	const { banner = '' } = business !== undefined ? getBusinessImages(business) : {};

	return (
		<div className={styles.BusinessBanner}>
			<QuirkImage alt={business?.name ?? ''} src={banner} />
		</div>
	);
}
